// extracted by mini-css-extract-plugin
module.exports = {"baseMenuItem":"BaseMenuItem_baseMenuItem__HefIz","label":"BaseMenuItem_label__XBNw7"};